<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { useTask } from "@/composables/tasks/useTask";
import { useRoute } from "vue-router";
import { normalizeRouteParam } from "@/utils/v2/routes";
import { TasksService } from "@/services/v2/tasks";
import { useTasksStore } from "@/stores/v2";
import { onMounted } from "vue";

import EnvAttrsModifier from "@/components/v2/Tasks/EnvAttrsModifier/index.vue";
import LayoutMain from "@/components/v2/Layouts/LayoutMain.vue";

const { startObserver } = useTask();
const route = useRoute();
const taskKey = normalizeRouteParam(route.params.key)

const init = async () => {
  try {
    const task = await TasksService.startTask(taskKey);
    if (!task) {
      return
    }
    await useTasksStore().setActiveTask(task);

    startObserver();
  } catch (err) {
    alert("Error during initialization:" + err);
  }
};

onMounted(init);
</script>

<template>
  <LayoutMain>
    <template #mainArea>
      <EnvAttrsModifier />
    </template>
  </LayoutMain>
</template>


<style scoped>
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>